import React from 'react';

import css from './DebugOutput.module.scss';

const DebugOutput = ({message}) => {
    // TODO: improve with/from config for go live

    return <pre className={css.debug}>{message}</pre>;
};

export default DebugOutput;
